'use client';

import { useSearchParams } from 'next/navigation';
import { type ComponentProps, Suspense } from 'react';

import { CampaignsBigCampaign2026 } from '@/app/lcv/components/campaigns/big-campaign-2026';

type OfferEntryProps = Omit<
  Extract<
    ComponentProps<typeof CampaignsBigCampaign2026>,
    { variant: 'offer' }
  >,
  'preSelectedModelCode'
>;

const CampaignWithModelCode = (props: OfferEntryProps) => {
  const modelCode = useSearchParams()?.get('modelCode') ?? '';

  return (
    <CampaignsBigCampaign2026 {...props} preSelectedModelCode={modelCode} />
  );
};

// Offer pages are prerendered: read `?modelCode=` in the browser (only that param).
export const OfferEntry = (props: OfferEntryProps) => (
  <Suspense fallback={<CampaignsBigCampaign2026 {...props} />}>
    <CampaignWithModelCode {...props} />
  </Suspense>
);
